// extracted by mini-css-extract-plugin
module.exports = {"csr-B":"B_csr-B__E8ku2","circleWave":"B_circleWave__jM3Qw"};